<template>

  <div v-show="showMoreDetailsModal">
    <div v-if="DataLoading">
      <div class="modal-overlay" >
            <center><div class="loader" style="margin-top: 160px;"></div></center>
          </div>
              </div>
              <div v-else>
      <div v-show="showModal">
     <div class="modal-overlay" >
      <Modal class="custom-modal custom-modal-width2" v-show="showMoreDetailsModal">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <div v-if="selectedTab === 'Business Details'" class="modal-header-text2">
                      More Details <br>
                      <div class="modal-text3">To change any of these details, kindly reach out</div>
                      <div class="modal-text3">to support</div>
              </div>
              <div v-if="selectedTab === 'Business Document'" class="modal-header-text2">
                      Account Settings <br>
                      <div class="modal-text3">To change any of these details, kindly reach out</div>
                      <div class="modal-text3">to support</div>
              </div>
              <div v-if="selectedTab === 'Bank Details'" class="modal-header-text2">
                  Account Settings <br>
                      <div class="modal-text3">To change any of these details, kindly reach out</div>
                      <div class="modal-text3">to support</div>
              </div>
                  <button type="button" class="close" @click="CloseMoreDetailsModal(1)">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
              <div class="modal-header-container">
          <div class="tab-buttons2">
          
          <button
            :class="{ activeTab: selectedTab === 'Business Details' }"
            @click="selectTab('Business Details')"
          >
            Business Details
          </button>
          <button
            :class="{ activeTab: selectedTab === 'Business Document' }"
            @click="selectTab('Business Document')"
          >
            Business Document
          </button>
          <button
            :class="{ activeTab: selectedTab === 'Bank Details' }"
            @click="selectTab('Bank Details')"
          >
            Bank Details
          </button>
        </div>
                  </div>
  
            <div class="modal-body modal-body9 modal-text" style="max-height: 420px;">
  
  
              <div v-if="selectedTab === 'Business Details'">
              <div class="form-group">
              <label for="businessType">Type:</label>
              <input type="text" id="Type" class="form-control" disabled v-model="Type" placeholder="Club" style="font-size: 12px; color: #000 background-color: #F8F9FC">
              </div>
          
  
  
              <!-- Business Name -->
              <div class="form-group">
                <label for="businessName">Business Name:</label>
                <input type="text" id="businessName" class="form-control" disabled v-model="businessName" placeholder="Cubana Club" style="font-size: 12px; background-color: #F8F9FC">
              </div>
  
              <!-- Email Address -->
              <div class="form-group">
                <label for="email">Email Address:</label>
                <input type="email" id="email" class="form-control" v-model="email" disabled placeholder="cubanaclub@gmail.com" style="font-size: 12px; background-color: #F8F9FC">
              </div>
  
              <!-- Tax Identification Number -->
              <div class="form-group">
                <label for="taxNumber">Tax Identification Number:</label>
                <input type="text" id="taxNumber" class="form-control" disabled v-model="taxNumber" placeholder="123456789" style="font-size: 12px; background-color: #F8F9FC">
              </div>
  
              <!-- Phone Number -->
              <div class="form-group">
                <label for="phoneNumber">Phone Number:</label>
                <input type="tel" id="phoneNumber" class="form-control" v-model="phoneNumber" disabled placeholder="090123456789" style="font-size: 12px; background-color: #F8F9FC;">
              </div>
              </div>
  
              <div v-if="selectedTab === 'Business Document'">
              <div class="form-group">
              <label for="GovID">Government Issued ID Type</label>
              <input type="text" id="IDType" class="form-control" v-model="IDType" disabled placeholder="Passport" style="font-size: 12px; background-color: #F8F9FC">
            </div>
  
  
              <!-- ID Type Number -->
              <div class="form-group">
                <input type="text" id="IDType" class="form-control" v-model="GovIDNumber" disabled placeholder="" style="font-size: 12px; background-color: #F8F9FC">
              </div>
  
              <div class="file-upload-section" @click="openDocumentModal1" style="font-size: 12px; background-color: #F8F9FC;">
              <label for="govtIdUpload" class="upload-label">
                  <img src="@/components/img/Sales_Assests/pdf-icon.svg" alt="PDF Icon">
                        {{GovIDName}}
              </label>
              <input type="file" id="govtIdUpload" disabled class="file-input" @change="handleFileChange" v-if="!uploadedFile">
            </div>
           
            
            <div class="file-upload-section" @click="openDocumentModal2" disabled style="font-size: 12px; background-color: #F8F9FC">
              <label for="businessType">Utility Bill</label>
              <label for="utilitybill" class="upload-label">
                  <img src="@/components/img/Sales_Assests/pdf-icon.svg" alt="PDF Icon">
                          {{utilitybillName}}
              </label>
              <input type="file" id="utilitybill" disabled ref="utilitybill" class="file-input" @change="handleFileChangeUtility" v-if="!uploadedUtilityBill">
            </div><br>
  
            <div class="form-group">
              <label for="RegCode">Business Registration Code</label>
              <input type="text" id="RegCode" class="form-control" disabled v-model="RegCode" placeholder="" style="font-size: 12px; background-color: #F8F9FC">
              </div>
  
              
            <div class="file-upload-section" @click="openDocumentModal3" disabled style="font-size: 12px; background-color: #F8F9FC">
              <label for="CACDocument">C.A.C Document</label>
              <label for="CACDocument" class="upload-label">
                  <img src="@/components/img/Sales_Assests/pdf-icon.svg" alt="PDF Icon">
                          {{CACDocumentName}}
              </label>
              <input type="file" id="CACDocument" disabled ref="CACDocument" class="file-input" @change="handleFileChangeCAC" v-if="!uploadedCAC">
            </div>
          </div>
  
          <div v-if="selectedTab === 'Bank Details'">
          <div class="form-group">
                <label for="acctNumber">Account Number</label>
                <input type="text" id="acctNumber" class="form-control" disabled v-model="acctNumber" placeholder="1234567890" style="font-size: 12px; background-color: #F8F9FC">
              </div>
  
           
              <!-- Banks -->
              <div class="form-group">
              <label for="bank">Bank</label>
              <input type="text" id="acctName" class="form-control" disabled v-model="BankName" placeholder="Readycash" style="font-size: 12px; background-color: #F8F9FC">
            </div>
  
              <!-- Account Inquiry -->
              <div class="form-group">
                <label for="acctName">Account Name</label>
                <input type="text" id="acctName" class="form-control" disabled v-model="acctName" placeholder="Obi Cubana" style="font-size: 12px; background-color: #F8F9FC">
              </div>
  
              <!-- Upload Indemnity -->
              <div class="file-upload-section"  @click="openDocumentModal4" disabled style="font-size: 12px; background-color: #F8F9FC">
              <label for="indemnity" class="upload-label">
                  <img src="@/components/img/Sales_Assests/pdf-icon.svg" alt="PDF Icon">
                         {{GovIDDoc}}
              </label>
              <input type="file" id="indemnity" ref="indemnity" disabled class="file-input" @change="handleFileChangeIndemnity" v-if="!uplouploadedIndemnityadedFile">
            </div><hr><hr>
          </div>
  
            </div>
  
          </div>
        </div>
      </Modal>
    </div>
    </div>
    <div v-if="showGoVIDDocument" class="pdf-viewer-overlay">
            <div class="pdf-viewer">
              <!-- Inside your template -->
              <iframe :src="getDocumentUrl(IDGovDocument, IDGovDocumentMIMEType)" class="pdf-viewer-iframe"  controls="0"></iframe>
  
  
              <button @click="closeDocumentModal1" class="btn btn-danger">Close</button>
              </div>
          </div>
  
    <div v-if="showUtilityDocument" class="pdf-viewer-overlay">
      <div class="pdf-viewer">
        <!-- Inside your template -->
        <iframe :src="getDocumentUrl(utilitybillDocument, utilitybillMIMEType)" class="pdf-viewer-iframe"  controls="0"></iframe>
  
  
        <button @click="closeDocumentModal2" class="btn btn-danger">Close</button>
        </div>
    </div>
  
    <div v-if="showCACDocument" class="pdf-viewer-overlay">
      <div class="pdf-viewer">
        <!-- Inside your template -->
        <iframe :src="getDocumentUrl(CACDocument, CACDocumentMIMEType)" class="pdf-viewer-iframe"  controls="0"></iframe>
  
  
        <button @click="closeDocumentModal3" class="btn btn-danger">Close</button>
        </div>
    </div>
    <div v-if="showindemnityDocument" class="pdf-viewer-overlay">
      <div class="pdf-viewer">
        <!-- Inside your template -->
        <iframe :src="getDocumentUrl(IndemnityDocument, IndemnityDocumentMIMEType)" class="pdf-viewer-iframe"  controls="0"></iframe>
  
  
        <button @click="closeDocumentModal4" class="btn btn-danger">Close</button>
        </div>
    </div>
    </div>
  </div>
  
  </template>
  
  <script>
  import axios from 'axios';
  import debounce from 'lodash/debounce';
  
    
  export default {
    props: ['showMoreDetailsModal','currentBusinessID','currentMerchantID'],
  
    data() {
    return {
      selectedTab: 'Business Details',
      MerchantDetails: null,
      BusinessDetails: null,
      BankDetails: null,
      BusinessDocuments: null,
      DataLoading: true,
      banks: null,
      showGoVIDDocument: false,
      showUtilityDocument: false,
      showCACDocument: false,
      showindemnityDocument: false,
      showModal: true,
  
      Type: '',
      businessName: '',
      email: '',
      taxNumber: '',
      phoneNumber: '',
      IDType: '',
      GovIDNumber: '',
      RegCode: '',
      acctNumber: '',
      BankName: '',
      acctName: '',
      GovIDDoc: null,
      GovIDName: '',
      utilitybillName: '',
      CACDocumentName: '',
      IDGovDocument: null,
      IDGovDocumentMIMEType: null,
      utilitybillDocument: null,
      utilitybillMIMEType: null,
      CACDocument: null,
      CACDocumentMIMEType: null,
      IndemnityDocument: null,
      IndemnityDocumentMIMEType: null,
  
    }
  },
  
  
  watch: {
  
  showMoreDetailsModal: {
  handler: debounce(function(newValue) {
    if (this.showMoreDetailsModal) {
      this.fetchMerchantsDetails();
      console.log(newValue)
    }
  }, 1000),
  immediate: true,
  },
    },
  
  methods: {
  
    openDocumentModal4() {
        this.showindemnityDocument = true;
        this.showModal = false;
      },
  
      closeDocumentModal4() {
        this.showindemnityDocument = false;
        this.showModal = true;
      },
  
    openDocumentModal3() {
        this.showCACDocument = true;
        this.showModal = false;
      },
  
      closeDocumentModal3() {
        this.showCACDocument = false;
        this.showModal = true;
      },
  
    openDocumentModal2() {
        this.showUtilityDocument = true;
        this.showModal = false;
      },
  
      closeDocumentModal2() {
        this.showUtilityDocument = false;
        this.showModal = true;
      },
  
    openDocumentModal1() {
        this.showGoVIDDocument = true;
        this.showModal = false;
      },
  
      closeDocumentModal1() {
        this.showGoVIDDocument = false;
        this.showModal = true;
      },
  
    getDocumentUrl(base64String, format) {
        return `data:${format};base64,${base64String}`;
      },
  
    async callAccountInquiryAPI(bankCode, AccountNumber) {
      let acctName = null;
      try {
        const response = await axios.get(`${this.$config.ACCOUNTINQUIRY_ENDPOINT}/${AccountNumber}/bankCode/${bankCode}`);
        
        if(response.status == 200){
  
          if(response.data.data.name == 'Error getting account name'){
          acctName = 'UNABLE TO FETCH ACCOUNT NAME';
  
          } else {
           acctName = response.data.data.name;
          }
  
          return acctName;
      }
        
      } catch (error) {
        console.error('Request could not be completed, Please try again later.', error);
      }
    },
  
    async getBankName(code) {
      try{
        await this.fetchBanks();
      } catch(error){
        console.log(error);
      }
        const selectedBank = this.banks.find(bank => bank.code === code);
        return selectedBank ? selectedBank.name : '';
      },
  
    async fetchBanks() {
        try {
          const response = await axios.get(this.$config.GETBANKCODE_ENDPOINT);
          this.banks = response.data.data;
        } catch (error) {
          console.error('Error fetching banks:', error);
        }
      },
  
    async fetchMerchantsDetails(){
      try {
          this.DataLoading = true;
          const response = await axios.get(`${this.$config.MERCHARNTDATA_ENDPOINT}/${this.currentMerchantID}/business/${this.currentBusinessID}`);
          if(response.status == 200){
          this.MerchantDetails = response.data.data;
          this.BusinessDetails = this.MerchantDetails.businessDetails;
          this.BankDetails = this.MerchantDetails.bankDetails;
          this.BusinessDocuments = this.MerchantDetails.businessDocuments;
  
          //Set  Data for Business Details fields
  
          this.Type = this.BusinessDetails.type;
          this.businessName = this.BusinessDetails.name;
          this.email = this.BusinessDetails.email;
          this.taxNumber = this.BusinessDetails.tin;
          this.phoneNumber = this.BusinessDetails.phoneNumber;
  
          //Set  Data for Bank Details fields
  
          this.acctNumber = this.BankDetails.accountNumber;
          this.acctName = await this.callAccountInquiryAPI(this.BankDetails.bankCode,this.BankDetails.accountNumber );
          this.BankName = await this.getBankName(this.BankDetails.bankCode);
          this.GovIDDoc = this.BusinessDocuments[3].filename;
          this.IndemnityDocument = this.BusinessDocuments[3].base64Content;
          this.IndemnityDocumentMIMEType = this.BusinessDocuments[3].mimeType;
  
          //Set  Data for Documents fields
  
          this.IDType = this.BusinessDocuments[0].documentType;
          this.IDGovDocument = this.BusinessDocuments[0].base64Content;
          this.IDGovDocumentMIMEType = this.BusinessDocuments[0].mimeType;
          this.GovIDName = this.BusinessDocuments[0].filename;
  
          this.utilitybillName = this.BusinessDocuments[1].filename;
          this.utilitybillDocument = this.BusinessDocuments[1].base64Content;
          this.utilitybillMIMEType = this.BusinessDocuments[1].mimeType;
  
          this.CACDocumentName = this.BusinessDocuments[2].filename;
          this.CACDocument = this.BusinessDocuments[2].base64Content;
          this.CACDocumentMIMEType = this.BusinessDocuments[2].mimeType;
  
          this.DataLoading = false;
          }
          else{
            this.DataLoading = false;
            this.$emit('close-modal');
            this.$toast.open({
            message: 'An error occurred while fetching merchant details',
            type: 'error',
            duration: 3000,
            });
          }
        } catch (error) {
          this.DataLoading = false;
            this.$emit('close-modal');
          this.$toast.open({
            message: 'An error occurred while fetching merchant details',
            type: 'error',
            duration: 3000,
            });
          console.error(error);
        }
  
    },
      CloseMoreDetailsModal(){
          this.$emit('close-modal');
  
      },
  
      selectTab(tab) {
      this.selectedTab = tab;
    
    },
  }
  
  }
  
  </script>
  
  <style scoped>
  
  .pdf-viewer {
    width: 100%; /* Adjust width as needed */
    height: 700px; /* Adjust height as needed */
    border: none;
  }
  
  
  .pdf-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1002;
    background-color: #fff;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  .pdf-viewer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.8);
    align-items: center;
    z-index: 1001;
  }
  
  .pdf-viewer {
    width: 90%; /* Adjust width as needed */
    max-width: 1200px; /* Set a maximum width if needed */
    height: 85%; /* Adjust height as needed */
    max-height: 900px; /* Set a maximum height if needed */
    background-color: transparent;
    padding: 10px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  }
  
  .pdf-viewer-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
  
  .modal-body-detail {
    max-height: 350px;
    overflow-y: auto;
  }
  
  .tab-buttons2 {
    display: flex;
    margin-bottom: 15px;
  }
  
  .tab-buttons2 button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 14px;
    margin-right: 10px;
    padding: 10px;
    color: #b0a8a8;
    width: 140px;
    height: 30px;
    font-size: 13px;
  }
  
  .tab-buttons2 button.activeTab {
    border-bottom: 2px solid #6F48FF; /* Active tab indicator color */
    color: #000; /* Active tab text color */
    font-weight: bold;
  }
  
  </style>